console.log("✅ custom.js chargé (Story drawer: close+open)");

const BONUS_VARIANT_ID = 50555981431073;
const nativeFetch = window.fetch.bind(window);

let running = false;
let addingBonus = false;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

function isAddToCartUrl(url) {
  if (!url) return false;
  return String(url).includes("/cart/add");
}

async function getCart() {
  return nativeFetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
}

async function waitForMainItem(timeoutMs = 5000) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const cart = await getCart();
    const hasNonBonus = cart.items?.some((i) => i.id !== BONUS_VARIANT_ID);
    if (hasNonBonus) return cart;
    await sleep(150);
  }
  return getCart();
}

async function addBonusIfNeeded() {
  if (addingBonus) return;

  const cart = await getCart();
  const alreadyThere = cart.items?.some((i) => i.id === BONUS_VARIANT_ID);
  if (alreadyThere) return;

  addingBonus = true;
  try {
    await nativeFetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: BONUS_VARIANT_ID, quantity: 1 }),
    });
    console.log("🎁 Bonus ajouté:", BONUS_VARIANT_ID);
  } catch (e) {
    console.error("❌ addBonusIfNeeded error:", e);
  } finally {
    addingBonus = false;
  }
}

// ✅ utilise TES classes HTML
function closeAndReopenStoryDrawer() {
  const closeBtn = document.querySelector(".js-drawer-close");
  const openBtn = document.querySelector(".js-drawer-open-button-right");

  if (!openBtn) {
    console.warn("⚠️ Bouton open drawer introuvable (.js-drawer-open-button-right)");
    return;
  }

  // Si on ne trouve pas le close, on fait juste open (ça refresh parfois quand même)
  try {
    if (closeBtn) closeBtn.click();
  } catch (e) {}

  setTimeout(() => {
    try {
      openBtn.click();
      console.log("🔄 Drawer re-ouvert pour refresh");
    } catch (e) {
      console.error("❌ Impossible de cliquer open drawer:", e);
    }
  }, 250);
}

async function handleAfterAddToCart() {
  if (running || addingBonus) return;
  running = true;

  try {
    // Laisser le thème ajouter l'item principal + ouvrir le drawer
    await sleep(200);

    // Attendre que l'item principal soit réellement dans le cart
    await waitForMainItem();

    // Ajouter bonus
    await addBonusIfNeeded();

    // Attendre que le cart soit persistant
    await sleep(350);

    // Refresh visuel du drawer (close/open)
    closeAndReopenStoryDrawer();
  } catch (e) {
    console.error("❌ handleAfterAddToCart error:", e);
  } finally {
    running = false;
  }
}

/* Hook XHR */
(function hookXHR() {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.___url = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      if (isAddToCartUrl(this.___url) && !addingBonus) {
        console.log("🧲 Add-to-cart détecté (XHR):", this.___url);
        handleAfterAddToCart();
      }
    });
    return originalSend.apply(this, args);
  };

  console.log("✅ Hook XHR installé");
})();

/* Hook fetch (au cas où) */
(function hookFetch() {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
    const res = await originalFetch.apply(this, args);

    if (isAddToCartUrl(url) && !addingBonus) {
      console.log("🧲 Add-to-cart détecté (fetch):", url);
      handleAfterAddToCart();
    }
    return res;
  };

  console.log("✅ Hook fetch installé");
})();
